module.exports = __webpack_public_path__ + "img/M2.821633fd.png";